{
    "EvaluationsData": [
        {
            "Team": "Agent",
            "Agent": "Oscar Donan",
            "Evaluations": 29,
            "AvgScore": 50.21,
            "Variance": 18.01
        },
        {
            "Team": "Agent",
            "Agent": "Parimala Admin",
            "Evaluations": 40,
            "AvgScore": 18.25,
            "Variance": -13.95
        },
        {
            "Team": "CV CXONE",
            "Agent": "Ankit Bhasin",
            "Evaluations": 30,
            "AvgScore": 60.5,
            "Variance": 10.23
        },
        {
            "Team": "CV CXONE",
            "Agent": "Ashish Kumbhar",
            "Evaluations": 15,
            "AvgScore": 40.05,
            "Variance": -10.22
        },
        {
            "Team": "CV ACD TEAM",
            "Agent": "Avihoo Cohen",
            "Evaluations": 18,
            "AvgScore": 17.3,
            "Variance": 0.27
        },
        {
            "Team": "CV Dashboard Team",
            "Agent": "Cade Rasmussen",
            "Evaluations": 10,
            "AvgScore": 9.20,
            "Variance": -19.65
        },
        {
            "Team": "CV Dashboard Team",
            "Agent": "Colton Visser",
            "Evaluations": 23,
            "AvgScore": 48.50,
            "Variance": 19.65
        },
        {
            "Team": "Calibration",
            "Agent": "Alexander Melera",
            "Evaluations": 50,
            "AvgScore": 44.6,
            "Variance": 6.33
        },
        {
            "Team": "Calibration",
            "Agent": "Alex",
            "Evaluations": 24,
            "AvgScore": 46,
            "Variance": 7.73
        },
        {
            "Team": "Calibration",
            "Agent": "Andrew Hicks",
            "Evaluations": 34,
            "AvgScore": 24.2,
            "Variance": -14.07
        },
        {
            "Team": "CEA Team",
            "Agent": "Ashadeepa Debnath",
            "Evaluations": 30,
            "AvgScore": 12.7,
            "Variance": 0.63
        },
        {
            "Team": "CV Integrations",
            "Agent": "Ashish Agent",
            "Evaluations": 15,
            "AvgScore": 16.5,
            "Variance": -13.18
        },
        {
            "Team": "CV Integrations",
            "Agent": "Parimal Agent",
            "Evaluations": 22,
            "AvgScore": 56.05,
            "Variance": 26.37
        },
        {
            "Team": "CV Integrations",
            "Agent": "Ben",
            "Evaluations": 10,
            "AvgScore": 16.5,
            "Variance": -13.18
        }
    ],
    "ChannelsData": [
        {
            "Team": "CV CXONE",
            "Agent": "Ankit Bhasin",
            "Chat": 25.01,
            "Email": 18.01,
            "Voice": 60.5
        },
        {
           "Team": "CV CXONE",
            "Agent": "Ashish Kumbhar",
            "Chat": 18.05,
            "Email": 27.10,
            "Voice": 8.05
        },
        {
            "Team": "CV ACD TEAM",
            "Agent": "Avihoo Cohen",
            "Chat": 10.22,
            "Email": 17.13,
            "Voice": 20.01
        },
        {
           "Team": "Calibration",
            "Agent": "Alexander Melera",
            "Chat": 5.05,
            "Email": 19.02,
            "Voice": 20.5
        },
        {
           "Team": "Calibration",
            "Agent": "Andrew Hicks",
            "Chat": 7.21,
            "Email": 18.01,
            "Voice": 10.5
        }
    ]
}